/**
 * Картинка с текстом внутри — своя для каждого языка.
 *
 * Часть графики на лендинге не вёрстка, а готовые файлы, и надписи в них
 * растровые: шаги онбординга, скриншоты. Английская версия сайта показывала
 * их с русским текстом — переключать через $t нечего, переводить надо сам
 * файл.
 *
 * Английские варианты лежат рядом, в /images/en/ под теми же именами: так
 * видно, для какой картинки перевод есть, и не нужен реестр соответствий.
 * Если файла нет — остаётся русский, это лучше битой картинки.
 */
const TRANSLATED = new Set([
  '/images/work-2.webp',
  '/images/work-3.webp',
  '/images/work-4.webp',
  '/images/sovcombank.svg',
  '/images/vtb.svg',
  '/images/finam.svg',
  '/images/viking.svg',
  '/images/about-card-1.webp',
  '/images/about-card-2.webp',
  // Логотип из макета, вариант Eng: «ADF Capital» вместо «АДФ Капитал»
  '/images/logo.svg',
])

export const useLocalizedImage = () => {
  const { locale } = useI18n()

  return (path: string) => {
    if (locale.value === 'ru' || !TRANSLATED.has(path)) return path

    return path.replace('/images/', `/images/${locale.value}/`)
  }
}
